import { cn } from '@shared/utils/utils';
import { EyeIcon, EyeOffIcon } from 'lucide-react';
import * as React from 'react';
import { MAX_LENGTH } from '../constants/common.constants';

export interface InputProps
    extends React.InputHTMLAttributes<HTMLInputElement> {
}

const Input = React.forwardRef<HTMLInputElement, InputProps>(
    ({ className, type, maxLength = MAX_LENGTH.Input, ...props }, ref) => {
        return (
            <input
                type={type}
                className={cn(
                    'flex h-10 w-full rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:border-primary disabled:cursor-not-allowed disabled:opacity-50',
                    className
                )}
                ref={ref}
                maxLength={maxLength}
                {...props}
            />
        );
    }
);
Input.displayName = 'Input';

export interface PasswordInputProps
    extends React.InputHTMLAttributes<HTMLInputElement> {
    onToggleIcon?: () => void
}

const PasswordInput = React.forwardRef<HTMLInputElement, PasswordInputProps>(
    ({ type, onToggleIcon, ...props }, ref) => {
        return (
            <div className='relative'>
                <Input ref={ref} type={type} {...props} />
                {
                    type === 'password' ?
                        <EyeOffIcon className='absolute w-6 h-6 right-3 top-4 hover:cursor-pointer' onClick={onToggleIcon} /> :
                        <EyeIcon className='absolute w-6 h-6 right-3 top-4 hover:cursor-pointer' onClick={onToggleIcon} />
                }
            </div>
        );
    }
);
PasswordInput.displayName = 'PasswordInput';

export { Input, PasswordInput };
